import moment from 'moment';
import React, { Fragment } from 'react';
import PointerIcon from '../assets/icons/pointer.svg';
import WatchIcon from '../assets/icons/watch.svg';
import BtIcon from '../assets/icons/bt.svg';
import { EVENT_TYPE } from '../consts';
import { t } from '../multi-language/multi-lang.service';
function BpDataTable(_a) {
    var bpData = _a.bpData, thresholdsStatus = _a.thresholdsStatus;
    var tableHeads = ['date', 'time', 'sys', 'dia', ''];
    var getBodyHeight = function () {
        var total = 1;
        Object.values(bpData).forEach(function (day) {
            total += day.sys.length || 1;
        });
        return "".concat((total / 2) * 55, "px");
    };
    var getIconByType = function (type) {
        switch ("".concat(type)) {
            case EVENT_TYPE.SYSTOLIC:
            case EVENT_TYPE.DIASTOLIC:
                return WatchIcon;
            case EVENT_TYPE.SYSTOLIC_MANUAL:
            case EVENT_TYPE.DIASTOLIC_MANUAL:
                return PointerIcon;
            case EVENT_TYPE.SYSTOLIC_EXTERNAL:
            case EVENT_TYPE.DIASTOLIC_EXTERNAL:
                return BtIcon;
            default: return '';
        }
    };
    var bgColor = true;
    var getBgClass = function (meassursDay, index) {
        var colorClass = '';
        if (!meassursDay)
            colorClass = 'bp-bg-grey';
        if (meassursDay && bgColor)
            colorClass = '';
        if (meassursDay === index + 1 || !meassursDay)
            bgColor = !bgColor;
        return colorClass;
    };
    return (React.createElement("div", { className: 'wrap-bp-tables' },
        React.createElement("div", { className: "meassure-legends" },
            React.createElement("div", { className: "legend" },
                React.createElement("img", { src: PointerIcon, alt: "Manual messurments" }),
                React.createElement("span", null, t('charts.legends.manual_measure'))),
            React.createElement("div", { className: "legend" },
                React.createElement("img", { src: WatchIcon, alt: "Device messurments" }),
                React.createElement("span", null, t('charts.legends.device_measure'))),
            React.createElement("div", { className: "legend" },
                React.createElement("img", { src: BtIcon, alt: "manual measurement" }),
                React.createElement("span", null, t('charts.legends.external_measure')))),
        React.createElement("table", { className: "table text-start" },
            React.createElement("thead", null, Array(2).fill(null).map(function (e, index) {
                return React.createElement("tr", { key: index, className: 'table-titles' }, tableHeads.map(function (th) { return React.createElement("th", { key: th }, th && t("bp_report.".concat(th))); }));
            })),
            React.createElement("tbody", { style: { height: getBodyHeight() } }, Object.entries(bpData).map(function (bpDate) {
                return React.createElement(Fragment, { key: bpDate[0] },
                    !bpDate[1].sys.length && React.createElement("tr", { key: bpDate[0], className: "first-in-day ".concat(getBgClass(0, 0)) },
                        React.createElement("td", null, moment(bpDate[0], 'YYYY-MM-DD').format('MMM DD, YYYY')),
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", null)),
                    bpDate[1].sys.map(function (sys, index, arr) {
                        return React.createElement("tr", { key: sys.timestamp, className: "".concat(getBgClass(arr.length, index), " ").concat(!index ? 'first-in-day' : index === arr.length ? 'last-in-day' : '') },
                            React.createElement("td", { className: 'date-column' },
                                React.createElement("span", null, moment(bpDate[0], 'YYYY-MM-DD').format('MMM DD, YYYY'))),
                            React.createElement("td", null, moment(sys.timestamp).format('HH:mm')),
                            React.createElement("td", { className: "bp-value ".concat(sys.isAlert && thresholdsStatus === 'on' && 'bp-alert') }, sys.value),
                            React.createElement("td", { className: "bp-value ".concat(bpDate[1].dia[index].isAlert && thresholdsStatus === 'on' && 'bp-alert') }, bpDate[1].dia[index].value),
                            React.createElement("td", { className: 'bp-type-icon' },
                                React.createElement("img", { src: getIconByType(bpDate[1].dia[index].event_type), alt: "icon type" })));
                    }));
            })))));
}
export default BpDataTable;
//# sourceMappingURL=bp-data-table.js.map